import {sessionText} from "../../shared/sessionUi.js";
export const localeInfo = {
  en: {
 label: "English", dir: "ltr" },
  ar: {
 label: "العربية", dir: "rtl" },
};

export const dictionary = {
  en: {
    "Publisher inbox":"Publisher inbox",
    brand: "MayWade Real Estate",
    short: "MRE",
    navBuy: "Buy",
    navRent: "Rent",
    navProjects: "Projects",
    navInvest: "Invest",
    navServices: "Services",
    navCompare: "Compare",
    navPricing: "Plans",
    navDashboard: "Dashboard",
    login: "Login",
    heroTitle: "Oman real estate, clearer from search to signing.",
    heroText: "Buy, rent, compare, inspect, move, build, and review property decisions with premium Oman data and responsible AI workflows.",
    aiSearch: "AI property search",
    searchPlaceholder: "2-bedroom apartment near Al Mouj under 600 OMR with sea view",
    search: "Search",
    featured: "Featured Oman listings",
    topAreas: "Top Oman areas",
    projects: "Projects and off-plan",
    investments: "Investment interest",
    services: "Property services",
    trust: "Trust and observability",
    dashboard: "Workspace",
    admin: "Admin observability",
    government: "Government observer",
    disclaimer: "This estimate is informational only, may be inaccurate, and MayWade Real Estate takes no responsibility for investment decisions. Consult licensed financial, legal, and real estate professionals before investing.",
  },
  ar: {
    "Publisher inbox":"صندوق الناشر",
    brand: "ماي ويد للعقارات",
    short: "MRE",
    navBuy: "شراء",
    navRent: "إيجار",
    navProjects: "المشاريع",
    navInvest: "استثمار",
    navServices: "الخدمات",
    navCompare: "مقارنة",
    navPricing: "الباقات",
    navDashboard: "لوحة العمل",
    login: "دخول",
    heroTitle: "عقارات عُمان بوضوح من البحث حتى التعاقد.",
    heroText: "اشترِ، استأجر، قارن، افحص، انتقل، ابنِ، وراجع قراراتك العقارية ببيانات عُمانية وتجارب ذكاء اصطناعي مسؤولة.",
    aiSearch: "بحث عقاري بالذكاء الاصطناعي",
    searchPlaceholder: "شقة غرفتين قرب الموج أقل من 600 ريال بإطلالة بحرية",
    search: "بحث",
    featured: "عقارات مختارة في عُمان",
    topAreas: "أفضل مناطق عُمان",
    projects: "المشاريع وعلى الخارطة",
    investments: "اهتمام استثماري",
    services: "خدمات عقارية",
    trust: "الثقة والرقابة",
    dashboard: "مساحة العمل",
    admin: "رقابة الإدارة",
    government: "مراقب حكومي",
    disclaimer: "هذا التقدير معلوماتي فقط، وقد يكون غير دقيق، ولا تتحمل MayWade Real Estate أي مسؤولية عن قرارات الاستثمار. استشر مختصين ماليين وقانونيين وعقاريين مرخصين قبل الاستثمار.",
  },
};

Object.assign(dictionary.en, {
  "skip": "Skip to content",
  "navigation": "Navigation",
  "switchLanguage": "Switch to Arabic",
  "theme": "Change theme",
  "close": "Close",
  "areas": "Areas",
  "guides": "Guides",
  "contact": "Contact us",
  "omanMarketplace": "A place in Oman. A place of your own.",
  "editHeadline": "Find your",
  "editHeadlineAccent": "place in Oman.",
  "editIntro": "From a first apartment to a new family home. Explore properties, discover neighborhoods, and make your next move with MayWade.",
  "exploreHomes": "Explore the possibilities",
  "omanOnly": "Oman, thoughtfully connected",
  "coastAlt": "Coastal architecture at dusk — existing brand illustration",
  "coastalLiving": "A different perspective on home",
  "marketingImage": "Brand illustration",
  "discover": "Discover",
  "buyHome": "A home to own",
  "rentHome": "A place to rent",
  "discoverProjects": "Something new",
  "listProperty": "List your property",
  "freshMarket": "On the market",
  "latestHomes": "Your next chapter starts here.",
  "viewAll": "View all properties",
  "listingsUnavailable": "Properties are temporarily unavailable",
  "tryAgainDetail": "We couldn’t load the latest listings. Please try again.",
  "retry": "Try again",
  "noListings": "No properties to display yet",
  "noListingsDetail": "Check back for published properties.",
  "senseOfPlace": "A sense of place",
  "areaHeadline": "Find a neighborhood that feels like you.",
  "areaIntro": "Get to know the places behind the properties. Explore Oman’s neighborhoods before deciding where to call home.",
  "exploreAreas": "Explore neighborhoods",
  "exploreAtYourPace": "Every move begins with a place.",
  "areaFallback": "Neighborhood profiles will appear when available. Browse the area directory to explore.",
  "nextChapter": "For the steps that follow",
  "beyondSearch": "More clarity. At every step.",
  "guidanceIntro": "Practical tools and local services, from your first search to your next move.",
  "compareTitle": "See the whole picture",
  "compareCopy": "Compare property details side by side to understand your options.",
  "servicesTitle": "Find the right support",
  "servicesCopy": "Explore inspections, construction, maintenance, and moving services.",
  "guidesTitle": "Arrive better informed",
  "guidesCopy": "Read practical guides to property, neighborhoods, and moving in Oman.",
  "explore": "Explore",
  "hereToHelp": "Here for your next move",
  "nextMove": "Let’s take the next step.",
  "purpose": "Transaction",
  "searchInvitation": "A new beginning starts with a search.",
  "locationKeyword": "Location or keyword",
  "locationPlaceholder": "City, neighborhood, or property",
  "propertyType": "Property type",
  "allTypes": "All property types",
  "apartment": "Apartment",
  "villa": "Villa",
  "townhouse": "Townhouse",
  "land": "Land",
  "commercial": "Commercial",
  "searchProperties": "Find a property",
  "advanced": "Advanced search",
  "notFound": "This address leads somewhere else.",
  "notFoundCopy": "The page could not be found. Let’s help you find your way.",
  "backHome": "Back to home",
  "noPhoto": "Photo not provided",
  "property": "Property",
  "sale": "For sale",
  "rent": "For rent",
  "off_plan": "Off-plan",
  "investment": "Investment",
  "verified": "Verified",
  "priceUnavailable": "Price not provided",
  "month": "month",
  "save": "Save",
  "locationUnavailable": "Location not provided",
  "beds": "beds",
  "baths": "baths",
  "sqm": "m²",
  "selected": "Selected",
  "addCompare": "Add to comparison",
  "realEstate": "REAL ESTATE · OMAN",
  "resources": "Resources",
  "connect": "Connect",
  "calculators": "Calculators",
  "foreignerGuide": "Foreigner guide",
  "agents": "Agents & agencies",
  "footerIntro": "A considered approach to finding, comparing, and making a home in Oman.",
  "footerNote": "Property discovery. Informed decisions.",
  "marketplace": "Property marketplace",
  "buyTitle": "Find a home to call your own.",
  "rentTitle": "Find your next place to rent.",
  "searchTitle": "A place for your next chapter.",
  "searchHint": "Explore properties across Oman. Refine your search to find what fits.",
  "anyPurpose": "Any transaction",
  "sort": "Sort by",
  "newest": "Newest first",
  "price_low": "Price: low to high",
  "price_high": "Price: high to low",
  "rental_yield": "Rental yield",
  "completeness_score": "Listing completeness",
  "filters": "Filters",
  "apply": "Apply filters",
  "reset": "Reset",
  "mapArea": "Search area",
  "anyArea": "Any area",
  "saveSearch": "Save search",
  "results": "properties",
  "updating": "Updating properties…",
  "loading": "Loading properties…",
  "noMatches": "No properties match your search",
  "noMatchesCopy": "Try changing a filter or resetting your search.",
  "clear": "Clear",
  "previous": "Previous",
  "next": "Next",
  "page": "Page",
  "searchSaved": "Search saved with alerts enabled.",
  "loginRequired": "Please log in to use this action.",
  "favoriteSaved": "Property saved to your favorites.",
  "backResults": "Back to properties",
  "overview": "Overview",
  "amenities": "Amenities",
  "gallery": "Property gallery",
  "viewPhotos": "View photos",
  "photo": "Photo",
  "unavailable": "Property unavailable",
  "unavailableCopy": "This property could not be loaded. It may no longer be published.",
  "name": "Name",
  "email": "Email",
  "phone": "Phone",
  "message": "Message",
  "sending": "Sending…",
  "inquirySent": "Your inquiry has been sent.",
  "sendInquiry": "Send inquiry",
  "viewing": "Request viewing",
  "offer": "Make an offer",
  "applyRental": "Apply to rent",
  "documents": "Documents",
  "chat": "Chat",
  "welcome": "Welcome back.",
  "createAccount": "Make yourself at home.",
  "resetPassword": "Reset your password.",
  "authIntro": "Your properties. Your plans. All in one place.",
  "password": "Password",
  "role": "Account type",
  "register": "Create account",
  "sendReset": "Send reset link",
  "forgotPassword": "Forgot your password?",
  "backLogin": "Back to login",
  "needAccount": "New to MayWade? Create an account",
  "haveAccount": "Already have an account? Log in",
  "buyer": "Buyer",
  "renter": "Renter",
  "seller": "Seller",
  "agent": "Agent",
  "developer": "Developer",
  "pleaseWait": "Please wait…"
});
Object.assign(dictionary.ar, {
  "skip": "انتقل إلى المحتوى",
  "navigation": "التنقل",
  "switchLanguage": "Switch to English",
  "theme": "تغيير المظهر",
  "close": "إغلاق",
  "areas": "المناطق",
  "guides": "الأدلة",
  "contact": "تواصل معنا",
  "omanMarketplace": "مكان في عُمان. مكانٌ لك.",
  "editHeadline": "اعثر على",
  "editHeadlineAccent": "مكانك في عُمان.",
  "editIntro": "من شقتك الأولى إلى منزل العائلة الجديد. استكشف العقارات والأحياء، وخطّط لخطوتك القادمة مع ماي ويد.",
  "exploreHomes": "اكتشف الخيارات",
  "omanOnly": "عُمان، أقرب إليك",
  "coastAlt": "عمارة ساحلية عند الغسق — صورة توضيحية للعلامة",
  "coastalLiving": "نظرة مختلفة إلى معنى المنزل",
  "marketingImage": "صورة توضيحية",
  "discover": "اكتشف",
  "buyHome": "منزل للتملك",
  "rentHome": "مكان للإيجار",
  "discoverProjects": "مشاريع جديدة",
  "listProperty": "أضف عقارك",
  "freshMarket": "في السوق",
  "latestHomes": "هنا تبدأ حكايتك القادمة.",
  "viewAll": "عرض جميع العقارات",
  "listingsUnavailable": "العقارات غير متاحة مؤقتاً",
  "tryAgainDetail": "تعذّر تحميل أحدث العقارات. يرجى المحاولة مجدداً.",
  "retry": "حاول مجدداً",
  "noListings": "لا توجد عقارات للعرض حالياً",
  "noListingsDetail": "عد لاحقاً للاطلاع على العقارات المنشورة.",
  "senseOfPlace": "روح المكان",
  "areaHeadline": "اعثر على حيّ يشبهك.",
  "areaIntro": "تعرّف على الأماكن التي تحتضن العقارات. استكشف أحياء عُمان قبل أن تختار عنوانك الجديد.",
  "exploreAreas": "استكشف الأحياء",
  "exploreAtYourPace": "كل بداية تنطلق من مكان.",
  "areaFallback": "ستظهر ملفات الأحياء عند توفرها. تصفّح دليل المناطق للاستكشاف.",
  "nextChapter": "لخطواتك القادمة",
  "beyondSearch": "وضوح أكثر. في كل خطوة.",
  "guidanceIntro": "أدوات عملية وخدمات محلية، من بحثك الأول إلى انتقالك القادم.",
  "compareTitle": "شاهد الصورة كاملة",
  "compareCopy": "قارن تفاصيل العقارات جنباً إلى جنب لفهم خياراتك.",
  "servicesTitle": "اعثر على الدعم المناسب",
  "servicesCopy": "استكشف خدمات الفحص والبناء والصيانة والانتقال.",
  "guidesTitle": "ابدأ بمعرفة أوضح",
  "guidesCopy": "اقرأ أدلة عملية عن العقارات والأحياء والانتقال في عُمان.",
  "explore": "استكشف",
  "hereToHelp": "معك في خطوتك القادمة",
  "nextMove": "لنخطُ الخطوة القادمة معاً.",
  "purpose": "نوع المعاملة",
  "searchInvitation": "بداية جديدة تبدأ بالبحث.",
  "locationKeyword": "الموقع أو كلمة البحث",
  "locationPlaceholder": "مدينة أو حيّ أو عقار",
  "propertyType": "نوع العقار",
  "allTypes": "جميع أنواع العقارات",
  "apartment": "شقة",
  "villa": "فيلا",
  "townhouse": "تاون هاوس",
  "land": "أرض",
  "commercial": "تجاري",
  "searchProperties": "ابحث عن عقار",
  "advanced": "بحث متقدم",
  "notFound": "هذا العنوان يقود إلى مكان آخر.",
  "notFoundCopy": "تعذّر العثور على الصفحة. لنساعدك في الوصول إلى وجهتك.",
  "backHome": "العودة للرئيسية",
  "noPhoto": "لم تُرفق صورة",
  "property": "عقار",
  "sale": "للبيع",
  "rent": "للإيجار",
  "off_plan": "على الخارطة",
  "investment": "استثمار",
  "verified": "موثّق",
  "priceUnavailable": "السعر غير متوفر",
  "month": "شهر",
  "save": "حفظ",
  "locationUnavailable": "الموقع غير متوفر",
  "beds": "غرف نوم",
  "baths": "حمّامات",
  "sqm": "م²",
  "selected": "محدد",
  "addCompare": "أضف للمقارنة",
  "realEstate": "عقارات · عُمان",
  "resources": "موارد",
  "connect": "تواصل",
  "calculators": "الحاسبات",
  "foreignerGuide": "دليل الأجانب",
  "agents": "الوكلاء والوكالات",
  "footerIntro": "رؤية متأنية للبحث والمقارنة واختيار منزل في عُمان.",
  "footerNote": "اكتشاف العقارات. قرارات واعية.",
  "marketplace": "سوق العقارات",
  "buyTitle": "اعثر على منزل تسميه بيتك.",
  "rentTitle": "اعثر على مسكنك القادم للإيجار.",
  "searchTitle": "مكان لحكايتك القادمة.",
  "searchHint": "استكشف عقارات عُمان. خصّص بحثك لتجد ما يناسبك.",
  "anyPurpose": "جميع المعاملات",
  "sort": "ترتيب حسب",
  "newest": "الأحدث أولاً",
  "price_low": "السعر: من الأقل للأعلى",
  "price_high": "السعر: من الأعلى للأقل",
  "rental_yield": "العائد الإيجاري",
  "completeness_score": "اكتمال الإعلان",
  "filters": "عوامل التصفية",
  "apply": "تطبيق التصفية",
  "reset": "إعادة تعيين",
  "mapArea": "منطقة البحث",
  "anyArea": "جميع المناطق",
  "saveSearch": "حفظ البحث",
  "results": "عقارات",
  "updating": "جارٍ تحديث العقارات…",
  "loading": "جارٍ تحميل العقارات…",
  "noMatches": "لا توجد عقارات تطابق بحثك",
  "noMatchesCopy": "جرّب تغيير عوامل التصفية أو إعادة تعيين البحث.",
  "clear": "مسح",
  "previous": "السابق",
  "next": "التالي",
  "page": "صفحة",
  "searchSaved": "تم حفظ البحث مع تفعيل التنبيهات.",
  "loginRequired": "يرجى تسجيل الدخول لاستخدام هذا الإجراء.",
  "favoriteSaved": "تم حفظ العقار في المفضلة.",
  "backResults": "العودة إلى العقارات",
  "overview": "نظرة عامة",
  "amenities": "المرافق",
  "gallery": "صور العقار",
  "viewPhotos": "عرض الصور",
  "photo": "صورة",
  "unavailable": "العقار غير متاح",
  "unavailableCopy": "تعذّر تحميل العقار. ربما لم يعد منشوراً.",
  "name": "الاسم",
  "email": "البريد الإلكتروني",
  "phone": "الهاتف",
  "message": "الرسالة",
  "sending": "جارٍ الإرسال…",
  "inquirySent": "تم إرسال استفسارك.",
  "sendInquiry": "أرسل استفساراً",
  "viewing": "طلب معاينة",
  "offer": "تقديم عرض",
  "applyRental": "طلب استئجار",
  "documents": "المستندات",
  "chat": "محادثة",
  "welcome": "مرحباً بعودتك.",
  "createAccount": "أهلاً بك في بيتك.",
  "resetPassword": "إعادة تعيين كلمة المرور.",
  "authIntro": "عقاراتك وخططك، في مكان واحد.",
  "password": "كلمة المرور",
  "role": "نوع الحساب",
  "register": "إنشاء حساب",
  "sendReset": "إرسال رابط الاستعادة",
  "forgotPassword": "نسيت كلمة المرور؟",
  "backLogin": "العودة لتسجيل الدخول",
  "needAccount": "جديد في ماي ويد؟ أنشئ حساباً",
  "haveAccount": "لديك حساب؟ سجّل الدخول",
  "buyer": "مشترٍ",
  "renter": "مستأجر",
  "seller": "بائع",
  "agent": "وكيل",
  "developer": "مطوّر",
  "pleaseWait": "يرجى الانتظار…"
});

Object.assign(dictionary.ar, {
  "Nothing to show yet": "لا يوجد محتوى للعرض حالياً",
  "No live records matched this view.": "لا توجد سجلات متاحة لهذا العرض.",
  "Request failed": "تعذّر تحميل البيانات. يرجى المحاولة مجدداً.",
  "Contact": "تواصل",
  "Contact MayWade Real Estate": "تواصل مع ماي ويد للعقارات",
  "Marketplace support": "دعم السوق العقاري",
  "Demo MVP contact channel for Oman property, service, and account support.": "قناة تواصل للنسخة التجريبية لدعم العقارات والخدمات والحسابات في عُمان.",
  "Trust and compliance": "الثقة والامتثال",
  "Report listing, KYC, investment-discovery, or public profile concerns.": "أبلغ عن مشكلات الإعلانات أو التحقق من الهوية أو فرص الاستثمار أو الملفات العامة.",
  "Plans": "الباقات",
  "Plans and subscriptions": "الباقات والاشتراكات",
  "No active plans": "لا توجد باقات نشطة",
  "Publish active plans from admin before pricing is available.": "ستظهر الأسعار عند نشر الباقات النشطة.",
  "Areas": "المناطق",
  "Oman neighborhoods and ownership suitability": "أحياء عُمان وملاءمة التملك",
  "Services": "الخدمات",
  "Construction, moving, inspection, valuation, legal, and maintenance providers": "مقدمو خدمات البناء والانتقال والفحص والتقييم والدعم القانوني والصيانة",
  "Guides": "الأدلة",
  "Oman area, ownership, buying, renting, moving, and construction guides": "أدلة المناطق والتملك والشراء والإيجار والانتقال والبناء في عُمان",
  "Guide": "دليل",
  "Guide body": "محتوى الدليل",
  "Compare": "مقارنة",
  "Property comparison": "مقارنة العقارات",
  "No comparable listings": "لا توجد عقارات متاحة للمقارنة",
  "Published, approved listings are required before comparison can run.": "تتطلب المقارنة عقارات منشورة ومعتمدة.",
  "Professionals": "المختصون",
  "Agents, agencies, and developers": "الوكلاء والوكالات والمطورون",
  "Calculators": "الحاسبات",
  "Mortgage, affordability, and rental yield": "التمويل والقدرة الشرائية والعائد الإيجاري",
  "Project detail": "تفاصيل المشروع",
  "Project unavailable": "المشروع غير متاح",
  "Profile unavailable": "الملف غير متاح",
  "Guide unavailable": "الدليل غير متاح",
  "Foreigner guide": "دليل الأجانب",
  "Oman ownership eligibility": "أهلية التملك في عُمان",
  "Ownership eligibility": "أهلية التملك",
  "Nearby and cost": "المواقع القريبة والتكلفة",
  "Overview": "نظرة عامة",
  "Summary": "ملخص",
  "Milestones": "مراحل المشروع",
  "Profile": "الملف",
  "Agency profile": "ملف الوكالة",
  "Developer profile": "ملف المطور",
  "Compliance-ready": "الامتثال",
  "No approved investment opportunities": "لا توجد فرص استثمارية معتمدة",
  "Investment opportunities must be published and approved before appearing here.": "يجب نشر الفرص الاستثمارية واعتمادها قبل ظهورها هنا.",
  "Users": "المستخدمون",
  "Listings": "العقارات",
  "Projects": "المشاريع",
  "Investments": "الاستثمارات",
  "Leads": "الاستفسارات",
  "Appointments": "المواعيد",
  "Offers": "العروض",
  "Rental Apps": "طلبات الإيجار",
  "KYC": "التحقق من الهوية",
  "Wallet": "المحفظة",
  "Favorites": "المفضلة",
  "Saved Searches": "عمليات البحث المحفوظة",
  "Alerts": "التنبيهات",
  "Hidden": "المخفية",
  "Shortlists": "القوائم المختصرة",
  "Inspections": "الفحوصات",
  "Relocation": "الانتقال",
  "AI": "الذكاء الاصطناعي",
  "Notifications": "الإشعارات",
  "Reports": "التقارير",
  "Content": "المحتوى",
  "Settings": "الإعدادات",
  "signOut": "تسجيل الخروج",
  "aiSummary": "ملخص الذكاء الاصطناعي",
  "pricePerSqm": "سعر المتر المربع",
  "Starting price": "السعر الابتدائي",
  "Progress": "التقدم",
  "Risk": "المخاطر",
  "Rating": "التقييم",
  "Reviews": "المراجعات",
  "Branches": "الفروع",
  "Delivery score": "تقييم التسليم"
});
Object.assign(dictionary.en, { signOut: "Sign out", aiSummary: "AI summary", pricePerSqm: "Price per m²" });
export const t = (language, key) => dictionary[language]?.[key] || dictionary.en[key] || key;

Object.assign(dictionary.ar, {
  "Muscat coastal": "ساحل مسقط", "Al Mouj / Seeb": "الموج / السيب", "Qurum / Bawshar": "القرم / بوشر", "Salalah coast": "ساحل صلالة", "Duqm": "الدقم",
  "Developer and off-plan activity": "المطورون والمشاريع على الخارطة",
  "Login required to use this action.": "يرجى تسجيل الدخول لاستخدام هذا الإجراء.",
  "Viewing request sent.": "تم إرسال طلب المعاينة.",
  "Offer submitted for review.": "تم تقديم العرض للمراجعة.",
  "Rental application submitted.": "تم إرسال طلب الاستئجار.",
  "Document request created.": "تم إنشاء طلب المستندات.",
  "Conversation opened in your account.": "تم فتح محادثة في حسابك.",
  "Enter your email first.": "أدخل بريدك الإلكتروني أولاً.",
  "Type": "النوع", "Price": "السعر", "Area": "المنطقة", "Trust": "التوثيق", "Completeness": "الاكتمال",
  "ownershipType": "نوع الملكية", "foreignerEligible": "أهلية الأجانب", "ITCEligible": "أهلية المجمعات السياحية المتكاملة", "usufructEligible": "أهلية حق الانتفاع", "GCCEligible": "أهلية مواطني مجلس التعاون", "commercialOwnershipAllowed": "السماح بالتملك التجاري",
  "Area unavailable": "المنطقة غير متاحة", "Area guide": "دليل المنطقة", "Rental yield": "العائد الإيجاري", "Foreigner suitability": "الملاءمة للأجانب", "Best for": "الأنسب لـ", "Neighborhood overview": "نبذة عن الحي"
});

// Contemporary coastal editorial content; stock imagery is never listing inventory.
Object.assign(dictionary.en, {
  coastalHeadline: "Find a place.", coastalAccent: "Feel at home.",
  coastalIntro: "Discover homes, neighborhoods, and new possibilities in Oman.",
  coastalPlaces: "A place for your kind of life.",
  capitalCoast: "THE CAPITAL, BY THE SEA", southernCoast: "A SLOWER PACE",
  Muscat: "Muscat", Salalah: "Salalah",
  muscatMood: "City energy. Coastal calm.", salalahMood: "Space to breathe, room to belong.",
  muscatPhotoAlt: "Muttrah Corniche and the harbor in Muscat, Oman",
  illustrativeInterior: "Interior inspiration · Illustrative photography",
  freshMarket: "EXPLORE THE MARKET", latestHomes: "The latest places to call home.",
  omanMarketplace: "YOUR NEXT CHAPTER, IN OMAN", searchProperties: "Search",
  locationKeyword: "Location or keyword", searchInvitation: "A new beginning starts here."
});
Object.assign(dictionary.ar, {
  coastalHeadline: "اعثر على مكانك.", coastalAccent: "واشعر بالانتماء.",
  coastalIntro: "اكتشف المنازل والأحياء والفرص الجديدة في عُمان.",
  coastalPlaces: "مكان يناسب أسلوب حياتك.",
  capitalCoast: "العاصمة على البحر", southernCoast: "حياة بإيقاع أهدأ",
  Muscat: "مسقط", Salalah: "صلالة", muscatMood: "حيوية المدينة وهدوء الساحل.", salalahMood: "مساحة للراحة ومكان للانتماء.",
  muscatPhotoAlt: "كورنيش مطرح والميناء في مسقط، عُمان",
  illustrativeInterior: "إلهام للتصميم الداخلي · صورة توضيحية",
  freshMarket: "استكشف السوق", latestHomes: "أحدث الأماكن لتسميها بيتك.", omanMarketplace: "فصلك القادم في عُمان", searchProperties: "بحث", locationKeyword: "الموقع أو كلمة البحث", searchInvitation: "بداية جديدة تبدأ من هنا."
});

Object.assign(dictionary.en, {
 coastalHeroAlt: "The coast near Muscat, with the Al Bustan Palace Hotel and mountains across blue water",
 heroPhotoCaption: "Al Bustan coast, Muscat · Area inspiration",
 salalahPhotoAlt: "Palm trees and waves on the beach near Salalah at sunset",
 interiorPhotoAlt: "A bright living room with white cabinetry, timber flooring and large windows in Victoria, Australia",
 exteriorPhotoAlt: "Al Bustan Palace Hotel viewed from the beach in Muscat, Oman",
 photoCredits: "Photography credits", photoCreditNote: "Editorial photography, not advertised properties. Images cropped, resized and compressed. Adapted images retain their respective licenses."
});
Object.assign(dictionary.ar, {
 coastalHeroAlt: "الساحل قرب مسقط مع فندق قصر البستان والجبال خلف المياه الزرقاء",
 heroPhotoCaption: "ساحل البستان، مسقط · إلهام من المنطقة",
 salalahPhotoAlt: "نخيل وأمواج على شاطئ قرب صلالة عند الغروب",
 interiorPhotoAlt: "غرفة معيشة مضيئة بخزائن بيضاء وأرضية خشبية ونوافذ كبيرة في فيكتوريا، أستراليا",
 exteriorPhotoAlt: "فندق قصر البستان من الشاطئ في مسقط، عُمان",
 photoCredits: "حقوق الصور", photoCreditNote: "صور تحريرية لا تمثل عقارات معروضة. تم اقتصاص الصور وتغيير حجمها وضغطها. تحتفظ الصور المعدلة بتراخيصها الأصلية."
});

// Atlas editorial direction. Photography remains inspiration, never listing inventory.
Object.assign(dictionary.en, {
  atlasEyebrow: "OMAN, WITH A NEW PERSPECTIVE",
  atlasHeadline: "Find your place.", atlasHeadlineAccent: "Feel at home.",
  atlasIntro: "Some places just feel right. Discover homes, neighborhoods, and a way of life that feels like you.",
  atlasExplore: "Discover a different Oman", atlasCoastalLiving: "A sense of place",
  atlasMuscatOman: "Muscat, Oman", atlasSceneLabel: "A little inspiration for your next chapter",
  atlasSceneTitle: "Life, with a wider horizon.", atlasPopular: "Popular places", atlasAlMouj: "Al Mouj", atlasQurum: "Qurum",
  atlasYourOman: "Your Oman. Your perspective.", atlasJourney: "Choose your next move",
  atlasBuy: "Find a home to own", atlasBuyCopy: "A new chapter, on your terms.",
  atlasRent: "Find your next rental", atlasRentCopy: "More freedom. More possibilities.",
  atlasProjects: "Discover new projects", atlasProjectsCopy: "A fresh perspective on what’s next.",
  atlasPlacesTitle: "Different places.", atlasPlacesAccent: "Endless possibilities.",
  atlasPlacesCopy: "From the energy of the capital to the calm of the southern coast. Find the place that speaks to you.",
  atlasDestinationOne: "01 / THE CAPITAL", atlasDestinationTwo: "02 / THE SOUTH",
  atlasPlacesNote: "Every neighborhood has a story. Find yours.", atlasFindNeighborhood: "Find your neighborhood",
  atlasMarketTitle: "A new address.", atlasMarketAccent: "Your next chapter.",
  atlasGuidanceTitle: "A little clarity.", atlasGuidanceAccent: "A confident next step.",
  atlasConsidered: "A more considered move",
  atlasContactTitle: "Your next chapter", atlasContactAccent: "starts with a conversation.",
  atlasContactCopy: "Have a place in mind, or just a feeling? Let’s explore the possibilities together.", atlasLetsTalk: "Let’s talk",
  searchInvitation: "Good things begin with the right place.", searchProperties: "Find a property"
});
Object.assign(dictionary.ar, {
  atlasEyebrow: "عُمان، من منظور جديد",
  atlasHeadline: "اعثر على مكانك.", atlasHeadlineAccent: "واشعر بالانتماء.",
  atlasIntro: "بعض الأماكن تشبهنا. اكتشف المنازل والأحياء وأسلوب الحياة الذي يناسبك.",
  atlasExplore: "اكتشف عُمان بمنظور مختلف", atlasCoastalLiving: "إلهام من الساحل",
  atlasMuscatOman: "مسقط، عُمان", atlasSceneLabel: "إلهام لفصلك القادم",
  atlasSceneTitle: "حياة بأفق أوسع.", atlasPopular: "أماكن رائجة", atlasAlMouj: "الموج", atlasQurum: "القرم",
  atlasYourOman: "عُمانك. منظورك.", atlasJourney: "اختر خطوتك القادمة",
  atlasBuy: "اعثر على منزل لتملكه", atlasBuyCopy: "فصل جديد، على طريقتك.",
  atlasRent: "اعثر على منزلك المستأجر", atlasRentCopy: "حرية أكبر. احتمالات أكثر.",
  atlasProjects: "اكتشف المشاريع الجديدة", atlasProjectsCopy: "منظور جديد لما ينتظرك.",
  atlasPlacesTitle: "أماكن مختلفة.", atlasPlacesAccent: "احتمالات بلا حدود.",
  atlasPlacesCopy: "من حيوية العاصمة إلى هدوء الساحل الجنوبي. اعثر على المكان الذي يشبهك.",
  atlasDestinationOne: "٠١ / العاصمة", atlasDestinationTwo: "٠٢ / الجنوب",
  atlasPlacesNote: "لكل حي حكاية. اكتشف حكايتك.", atlasFindNeighborhood: "اعثر على حيّك",
  atlasMarketTitle: "عنوان جديد.", atlasMarketAccent: "فصلك القادم.",
  atlasGuidanceTitle: "رؤية أوضح.", atlasGuidanceAccent: "خطوة واثقة.",
  atlasConsidered: "خطوة مدروسة أكثر",
  atlasContactTitle: "فصلك القادم", atlasContactAccent: "يبدأ بمحادثة.",
  atlasContactCopy: "هل لديك مكان في ذهنك، أم مجرد حلم؟ لنستكشف الاحتمالات معاً.", atlasLetsTalk: "لنتحدث",
  searchInvitation: "البدايات الجميلة تبدأ بالمكان المناسب.", searchProperties: "ابحث عن عقار"
});

Object.assign(dictionary.en, {
  messagesTitle: "Messages", messagesInbox: "YOUR CONVERSATIONS", messagesConversations: "Conversations",
  messagesRefreshList: "Refresh conversations", messagesLoadingList: "Loading conversations…",
  messagesNoConversations: "No conversations yet", messagesStartHint: "Open a property and contact its advertiser to start a conversation.",
  messagesBrowse: "Browse properties", messagesConversation: "Conversation", messagesNoMessages: "No messages yet",
  messagesSelect: "Keep the conversation going", messagesSelectHint: "Choose a conversation to read messages and reply.",
  messagesProperty: "View property", messagesRefreshThread: "Refresh messages", messagesLoadingThread: "Loading messages…",
  messagesHistory: "Message history", messagesFirstMessage: "Start the conversation with your first message.",
  messagesYou: "You", messagesParticipant: "Participant", messagesWrite: "Your message", messagesPlaceholder: "Ask a question or share an update…",
  messagesRefreshHint: "Refresh to check for new replies.", messagesSending: "Sending…", messagesSend: "Send message",
  messagesSent: "Message sent.", messagesDraftKept: "Your draft has been kept.",
  messagesReadOnly: "This conversation is read-only. You can still read its messages.",
  messagesActive: "Active", messagesClosed: "Closed", messagesArchived: "Archived",
  messagesUnavailable: "This conversation is no longer available.", messagesAttachment: "Attachment",
  messagesRecentLimit: "Showing the 200 most recent messages."
});
Object.assign(dictionary.ar, {
  messagesTitle: "الرسائل", messagesInbox: "محادثاتك", messagesConversations: "المحادثات",
  messagesRefreshList: "تحديث المحادثات", messagesLoadingList: "جارٍ تحميل المحادثات…",
  messagesNoConversations: "لا توجد محادثات بعد", messagesStartHint: "افتح عقاراً وتواصل مع المُعلن لبدء محادثة.",
  messagesBrowse: "تصفّح العقارات", messagesConversation: "محادثة", messagesNoMessages: "لا توجد رسائل بعد",
  messagesSelect: "تابع المحادثة", messagesSelectHint: "اختر محادثة لقراءة الرسائل والرد عليها.",
  messagesProperty: "عرض العقار", messagesRefreshThread: "تحديث الرسائل", messagesLoadingThread: "جارٍ تحميل الرسائل…",
  messagesHistory: "سجل الرسائل", messagesFirstMessage: "ابدأ المحادثة برسالتك الأولى.",
  messagesYou: "أنت", messagesParticipant: "مشارك", messagesWrite: "رسالتك", messagesPlaceholder: "اطرح سؤالاً أو شارك تحديثاً…",
  messagesRefreshHint: "حدّث للاطلاع على الردود الجديدة.", messagesSending: "جارٍ الإرسال…", messagesSend: "إرسال الرسالة",
  messagesSent: "تم إرسال الرسالة.", messagesDraftKept: "تم الاحتفاظ بمسودة رسالتك.",
  messagesReadOnly: "هذه المحادثة للقراءة فقط. لا يزال بإمكانك قراءة رسائلها.",
  messagesActive: "نشطة", messagesClosed: "مغلقة", messagesArchived: "مؤرشفة",
  messagesUnavailable: "لم تعد هذه المحادثة متاحة.", messagesAttachment: "مرفق",
  messagesRecentLimit: "تُعرض أحدث ٢٠٠ رسالة."
});

Object.assign(dictionary.en, {
  collectionsEyebrow: "YOUR COLLECTION", collectionsSearchesTitle: "Saved searches", collectionsFavoritesTitle: "Favorites",
  collectionsSearchesIntro: "Pick up where you left off, with your filters and selected area ready.", collectionsFavoritesIntro: "Return to the properties, projects, and services you saved.",
  collectionsRefresh: "Refresh", collectionsLoading: "Loading your saved items…", collectionsRemove: "Remove", collectionsRemoving: "Removing…",
  collectionsSearchRemoved: "Saved search removed.", collectionsFavoriteRemoved: "Favorite removed.",
  collectionsNoSearches: "Your next search starts here", collectionsNoFavorites: "A place for your favorites",
  collectionsSearchHint: "Search for a property, choose your filters, then select Save search to keep them here.",
  collectionsFavoriteHint: "Use the heart on a property to add it to your favorites.",
  collectionsLimit: "Showing the 100 most recent saved items.", collectionsSavedOn: "Saved",
  collectionsSearch: "Saved search", collectionsProperty: "Saved property", collectionsProject: "Saved project", collectionsProvider: "Saved service provider", collectionsInvestment: "Saved investment", collectionsItem: "Saved item",
  collectionsOpenSearch: "Run this search", collectionsOpenItem: "View details", collectionsBrowseProviders: "Browse service providers", collectionsBrowseInvestments: "Browse investments",
  collectionsNoLink: "A link is not available for this saved item.", collectionsReference: "Reference", collectionsAlertsOn: "Alert preference: on", collectionsAlertsOff: "Alert preference: off",
  collectionsKeywords: "Keywords", collectionsSort: "Order", collectionsGovernorate: "Governorate", collectionsWilayat: "Wilayat", collectionsNeighborhood: "Neighborhood",
  collectionsForeignOwnership: "Foreign ownership", collectionsItc: "ITC eligibility", collectionsCommercialOwnership: "Commercial ownership",
  collectionsMinPrice: "Minimum price", collectionsMaxPrice: "Maximum price", collectionsMinArea: "Minimum area", collectionsMaxArea: "Maximum area", collectionsVerified: "Verified only", collectionsYes: "Yes", collectionsNo: "No"
});
Object.assign(dictionary.en, { collectionsLoadingDetails: "Loading property details…", collectionsDetailsRetry: "Details could not be loaded. Refresh to try again.", collectionsItemUnavailable: "This saved item is no longer available." });
Object.assign(dictionary.ar, {
  collectionsEyebrow: "مجموعتك", collectionsSearchesTitle: "عمليات البحث المحفوظة", collectionsFavoritesTitle: "المفضلة",
  collectionsSearchesIntro: "تابع من حيث توقفت مع مرشحاتك والمنطقة التي اخترتها.", collectionsFavoritesIntro: "عد إلى العقارات والمشاريع والخدمات التي حفظتها.",
  collectionsRefresh: "تحديث", collectionsLoading: "جارٍ تحميل العناصر المحفوظة…", collectionsRemove: "إزالة", collectionsRemoving: "جارٍ الإزالة…",
  collectionsSearchRemoved: "تمت إزالة البحث المحفوظ.", collectionsFavoriteRemoved: "تمت الإزالة من المفضلة.",
  collectionsNoSearches: "بحثك القادم يبدأ هنا", collectionsNoFavorites: "مكان لمفضلتك",
  collectionsSearchHint: "ابحث عن عقار واختر المرشحات ثم احفظ البحث للاحتفاظ به هنا.",
  collectionsFavoriteHint: "استخدم رمز القلب على العقار لإضافته إلى المفضلة.",
  collectionsLimit: "تُعرض أحدث ١٠٠ عنصر محفوظ.", collectionsSavedOn: "حُفظ في",
  collectionsSearch: "بحث محفوظ", collectionsProperty: "عقار محفوظ", collectionsProject: "مشروع محفوظ", collectionsProvider: "مقدم خدمة محفوظ", collectionsInvestment: "استثمار محفوظ", collectionsItem: "عنصر محفوظ",
  collectionsOpenSearch: "تنفيذ هذا البحث", collectionsOpenItem: "عرض التفاصيل", collectionsBrowseProviders: "تصفّح مقدمي الخدمات", collectionsBrowseInvestments: "تصفّح الاستثمارات",
  collectionsNoLink: "لا يتوفر رابط لهذا العنصر المحفوظ.", collectionsReference: "المرجع", collectionsAlertsOn: "تفضيل التنبيهات: مفعّل", collectionsAlertsOff: "تفضيل التنبيهات: متوقف",
  collectionsKeywords: "الكلمات المفتاحية", collectionsSort: "الترتيب", collectionsGovernorate: "المحافظة", collectionsWilayat: "الولاية", collectionsNeighborhood: "الحي",
  collectionsForeignOwnership: "تملك الأجانب", collectionsItc: "أهلية المجمع السياحي المتكامل", collectionsCommercialOwnership: "التملك التجاري",
  collectionsMinPrice: "أدنى سعر", collectionsMaxPrice: "أقصى سعر", collectionsMinArea: "أدنى مساحة", collectionsMaxArea: "أقصى مساحة", collectionsVerified: "الموثّقة فقط", collectionsYes: "نعم", collectionsNo: "لا"
});
Object.assign(dictionary.ar, { collectionsLoadingDetails: "جارٍ تحميل التفاصيل…", collectionsDetailsRetry: "تعذّر تحميل التفاصيل. حدّث للمحاولة مجدداً.", collectionsItemUnavailable: "لم يعد هذا العنصر المحفوظ متاحاً." });

Object.assign(dictionary.en, {
  calcTitle: "Make your next move with clarity.", calcMortgage: "Mortgage", calcAffordability: "Affordability", calcRentalYield: "Rental yield",
  calcInputs: "Your numbers", calcAssumptions: "Adjust the assumptions to explore a property that works for you.",
  calcPrice: "Property price (OMR)", calcDeposit: "Down payment (OMR)", calcRate: "Annual interest rate (%)", calcYears: "Loan term (years)",
  calcIncome: "Monthly income (OMR)", calcDebts: "Monthly debt payments (OMR)", calcRatio: "Income allocated to debt (%)", calcRent: "Monthly rent (OMR)", calcCosts: "Annual expenses (OMR)", calcVacancy: "Vacancy allowance (%)",
  calcPayment: "Estimated monthly payment", calcLoan: "Loan amount", calcInterest: "Total interest", calcRepayment: "Total loan repayments", calcBudget: "Estimated property budget", calcPaymentBudget: "Monthly payment budget", calcNetYield: "Estimated net yield", calcGrossYield: "Gross yield", calcNetIncome: "Annual net rental income", calcGrossIncome: "Annual gross rental income", calcReset: "Reset assumptions", calcEstimate: "A clearer picture", calcInvalid: "Check your inputs. Use positive amounts, a deposit no greater than the price, and a term between 1 and 50 years.",
  calcYieldNote: "Net yield includes your expense and vacancy assumptions. It excludes financing, taxes, purchase costs and changes in property value.",
  calcLoanNote: "Illustrative estimate at a fixed interest rate. Fees, insurance and bank eligibility checks are excluded. This is not a loan offer.",
});
Object.assign(dictionary.ar, {
  calcTitle: "خطوتك القادمة برؤية أوضح.", calcMortgage: "التمويل العقاري", calcAffordability: "القدرة الشرائية", calcRentalYield: "العائد الإيجاري",
  calcInputs: "أرقامك", calcAssumptions: "عدّل الافتراضات لاستكشاف العقار المناسب لك.",
  calcPrice: "سعر العقار (ر.ع.)", calcDeposit: "الدفعة المقدمة (ر.ع.)", calcRate: "معدل الفائدة السنوي (%)", calcYears: "مدة القرض (سنوات)",
  calcIncome: "الدخل الشهري (ر.ع.)", calcDebts: "أقساط الديون الشهرية (ر.ع.)", calcRatio: "نسبة الدخل المخصصة للديون (%)", calcRent: "الإيجار الشهري (ر.ع.)", calcCosts: "المصروفات السنوية (ر.ع.)", calcVacancy: "نسبة الشغور المتوقعة (%)",
  calcPayment: "القسط الشهري التقديري", calcLoan: "مبلغ القرض", calcInterest: "إجمالي الفوائد", calcRepayment: "إجمالي سداد القرض", calcBudget: "ميزانية العقار التقديرية", calcPaymentBudget: "ميزانية القسط الشهري", calcNetYield: "صافي العائد التقديري", calcGrossYield: "العائد الإجمالي", calcNetIncome: "صافي الدخل الإيجاري السنوي", calcGrossIncome: "إجمالي الدخل الإيجاري السنوي", calcReset: "إعادة ضبط الافتراضات", calcEstimate: "صورة أوضح", calcInvalid: "راجع القيم. استخدم مبالغ موجبة ودفعة مقدمة لا تتجاوز السعر ومدة بين سنة و٥٠ سنة.",
  calcYieldNote: "يشمل صافي العائد افتراضات المصروفات والشغور. ولا يشمل التمويل والضرائب وتكاليف الشراء وتغير قيمة العقار.",
  calcLoanNote: "تقدير توضيحي بمعدل فائدة ثابت، لا يشمل الرسوم والتأمين وشروط الأهلية البنكية. وليس عرض تمويل.",
  Messages: "الرسائل", "Request a viewing": "طلب معاينة", "Make an offer": "تقديم عرض", "Apply to rent": "طلب استئجار", "Request documents": "طلب مستندات",
  "Preferred date and time": "التاريخ والوقت المفضلان", "Times use your device’s local time zone. The owner must confirm availability.": "تُعرض الأوقات حسب المنطقة الزمنية لجهازك. يجب أن يؤكد المالك الموعد.",
  "Your offer (OMR)": "عرضك (ر.ع.)", Financing: "التمويل", Cash: "نقداً", Mortgage: "تمويل عقاري", "This submits an offer for review. Identity verification may be required.": "سيُرسل عرضك للمراجعة. قد يتطلب إكمال التحقق من الهوية.",
  "Preferred move-in date": "تاريخ الانتقال المفضل", "Household size": "عدد أفراد الأسرة", "Employment status (optional)": "الحالة الوظيفية (اختياري)", "Documents you need": "المستندات المطلوبة", "Additional notes (optional)": "ملاحظات إضافية (اختياري)", Cancel: "إلغاء", "Submit request": "إرسال الطلب",
  "This property is unavailable.": "هذا العقار غير متاح.", "Choose a viewing time in the future.": "اختر موعد معاينة في المستقبل.", "Enter an offer greater than zero.": "أدخل عرضاً أكبر من صفر.", "Choose a financing type.": "اختر نوع التمويل.", "Choose a move-in date from today onward.": "اختر تاريخ انتقال من اليوم فصاعداً.", "Enter a household size between 1 and 30.": "أدخل عدد أفراد الأسرة بين ١ و٣٠.", "Describe the documents you need.": "صف المستندات التي تحتاجها.", "This action is unavailable.": "هذا الإجراء غير متاح.",
  "Your offer was saved. Complete identity verification before it can proceed.": "تم حفظ عرضك. أكمل التحقق من الهوية لمتابعته.", "Your request was submitted successfully.": "تم إرسال طلبك بنجاح.", "Enter an email address or phone number so the owner can reply.": "أدخل بريداً إلكترونياً أو رقم هاتف ليتمكن المالك من الرد.",
  "Checking your session…": "جارٍ التحقق من جلستك…", "Your account is temporarily unavailable": "حسابك غير متاح مؤقتاً",
  "Unable to connect. Check your connection and try again.": "تعذر الاتصال. تحقق من اتصالك وحاول مجدداً.", "The request timed out. Please try again.": "انتهت مهلة الطلب. حاول مجدداً.", "The request was cancelled.": "تم إلغاء الطلب.", "The server returned an invalid response. Please try again.": "أعاد الخادم استجابة غير صالحة. حاول مجدداً.",
  "Password reset is not available yet. Please contact support for account recovery.": "إعادة تعيين كلمة المرور غير متاحة حالياً. تواصل مع الدعم لاستعادة حسابك.",
  "Identity verification": "التحقق من الهوية", "Submit a clear identity document for review.": "أرسل مستند هوية واضحاً للمراجعة.", "Start verification": "بدء التحقق", "Your verification profile is ready.": "ملف التحقق جاهز.", "Your document was submitted for review.": "تم إرسال مستندك للمراجعة.", "Verification status": "حالة التحقق", "Not started": "لم يبدأ", "Documents submitted": "المستندات المرسلة", "Upload document": "رفع مستند", "Document type": "نوع المستند", Passport: "جواز السفر", "National ID": "البطاقة الشخصية", "Residence card": "بطاقة الإقامة", "Identity document": "مستند الهوية", "JPEG, PNG, WebP or PDF. Maximum 5 MB.": "JPEG أو PNG أو WebP أو PDF. الحجم الأقصى ٥ ميجابايت.", "Submit for review": "إرسال للمراجعة",
  "Choose a document to upload.": "اختر مستنداً لرفعه.", "Choose a JPEG, PNG, WebP or PDF document.": "اختر مستند JPEG أو PNG أو WebP أو PDF.", "Documents must be between 1 byte and 5 MB.": "يجب أن يكون حجم المستند بين بايت واحد و٥ ميجابايت.", "The document could not be read. Please select it again.": "تعذرت قراءة المستند. اختره مجدداً.", "The document is unavailable.": "المستند غير متاح.", "Submitted document": "المستند المرسل", "View document": "عرض المستند", "Download document": "تنزيل المستند", "Close preview": "إغلاق المعاينة", "Loading…": "جارٍ التحميل…"
});

Object.assign(dictionary.ar, { "AI commentary is temporarily unavailable. Property figures are shown above.": "التعليق الذكي غير متاح مؤقتاً. تُعرض بيانات العقارات أعلاه." });

Object.assign(dictionary.ar, {
  "Choose two to four properties to compare.": "اختر عقارين إلى أربعة عقارات للمقارنة.",
  "Comparing…": "جارٍ إعداد المقارنة…", "Compare selected": "مقارنة المحدد", "Select": "اختيار", "Selected": "تم الاختيار",
  "Conversation opened in your account.": "تم فتح المحادثة في حسابك.",
  "Chat is unavailable until this listing has an owner.": "المحادثة غير متاحة حتى يُحدّد مالك الإعلان.",
  "Listing saved to favorites.": "تم حفظ العقار في المفضلة."
});

Object.assign(dictionary.ar, {
  "Service quotes": "عروض أسعار الخدمات", "Refresh quotes": "تحديث العروض",
  "Quotes for my requests": "عروض طلباتي", "My provider quotes": "عروضي كمزوّد خدمة",
  "Choose a service request": "اختر طلب خدمة", "Loading quotes…": "جارٍ تحميل العروض…",
  "Select your request to view its quotes.": "اختر طلبك لعرض عروض الأسعار الخاصة به.", "No quotes to display.": "لا توجد عروض لعرضها.",
  "Quote reference": "مرجع العرض", "Service request reference": "مرجع طلب الخدمة",
  "Quote amount (OMR)": "مبلغ العرض (ر.ع.)", "Timeline (days)": "المدة (أيام)", "Quote message": "رسالة العرض", days: "أيام",
  "Accept quote": "قبول العرض", "Reject quote": "رفض العرض", "Withdraw quote": "سحب العرض",
  "Submit a quote": "إرسال عرض سعر", "Submitting quote…": "جارٍ إرسال العرض…", "Saving quote…": "جارٍ حفظ القرار…",
  Submitted: "مُرسل", Accepted: "مقبول", Rejected: "مرفوض", Withdrawn: "مسحوب",
  "Quote decision saved.": "تم حفظ قرار العرض.", "Quote submitted.": "تم إرسال العرض.",
  "Service quote was not found.": "لم يُعثر على عرض الخدمة.", "Service request was not found.": "لم يُعثر على طلب الخدمة.",
  "An active account linked to an approved service provider is required.": "يلزم حساب نشط مرتبط بمزوّد خدمة معتمد.",
  "You cannot make this quote decision.": "ليس لديك صلاحية اتخاذ هذا القرار بشأن العرض.",
  "This service request is no longer open.": "طلب الخدمة هذا لم يعد مفتوحاً.",
  "This quote has changed. Refresh the quotes before deciding.": "تغيّر هذا العرض. حدّث العروض قبل اتخاذ القرار.",
  "This quote already has a different final decision.": "سبق اتخاذ قرار نهائي مختلف بشأن هذا العرض.",
  "Enter a positive OMR amount with at most three decimal places.": "أدخل مبلغاً موجباً بالريال العُماني لا يزيد على ثلاث منازل عشرية.",
  "Enter a non-negative whole number of days.": "أدخل عدداً صحيحاً غير سالب من الأيام.",
  "Check the quote fields and try again.": "تحقّق من بيانات العرض وحاول مجدداً.",
  "This submission key was already used for a different quote.": "استُخدم معرّف الإرسال هذا لعرض مختلف.",
  "Service quotes are read-only for support staff. Use the participant workflow.": "يمكن لفريق الدعم قراءة العروض فقط. استخدم إجراءات الطرف المشارك.",
  "Check the saved-search fields and try again.": "تحقّق من بيانات البحث المحفوظ وحاول مجدداً.",
  "Saved search was not found.": "لم يُعثر على البحث المحفوظ.",
  maintenance: "صيانة",
  "Authentication is required.": "يلزم تسجيل الدخول.",
  "Unauthenticated request.": "يلزم تسجيل الدخول لتنفيذ الطلب.",
  "You do not have permission to access this resource.": "ليس لديك صلاحية الوصول إلى هذا المورد.",
  "You do not have the permission to access this resource.": "ليس لديك صلاحية الوصول إلى هذا المورد.",
  "Account verification is temporarily unavailable. Please try again.": "التحقّق من الحساب غير متاح مؤقتاً. حاول مجدداً.",
  "No service requests yet. Create a request above.": "لا توجد طلبات خدمة بعد. أنشئ طلباً في الأعلى.",
  "The server returned an invalid response. Please try again.": "أعاد الخادم استجابة غير صالحة. حاول مجدداً.",
  "Unable to connect. Check your connection and try again.": "تعذّر الاتصال. تحقّق من اتصالك وحاول مجدداً.",
  "The request timed out. Please try again.": "انتهت مهلة الطلب. حاول مجدداً.",
  "The request was cancelled.": "تم إلغاء الطلب.",
  "Request failed": "تعذّر تنفيذ الطلب",
  "Quote service is temporarily unavailable. Please try again.": "خدمة عروض الأسعار غير متاحة مؤقتاً. حاول مجدداً.",
  "Amount unavailable": "المبلغ غير متاح", "Timeline unavailable": "المدة غير متاحة",
});

// Investment discovery remains nonbinding in both languages.
Object.assign(dictionary.ar, {
  "Interest only. No payment or contract.": "تسجيل اهتمام فقط، دون دفع أو عقد.",
  "Indicative yield (%)": "العائد الإرشادي (%)",
  "Funding target (OMR)": "المبلغ المستهدف (ر.ع.)",
  "Minimum expression of interest (OMR)": "الحد الأدنى الإرشادي للاهتمام (ر.ع.)",
  "Risk classification": "تصنيف المخاطر", Low: "منخفض", Medium: "متوسط", High: "مرتفع", "Not specified": "غير محدد",
  "Loading opportunities…": "جارٍ تحميل الفرص…",
  "No public investment opportunities are available.": "لا توجد فرص استثمارية متاحة للعرض العام حالياً.",
  "Accepting interest": "متاح لتسجيل الاهتمام", "Not accepting new interest": "غير متاح لتسجيل اهتمام جديد",
  "View opportunity": "عرض الفرصة", "Back to opportunities": "العودة إلى الفرص",
  "Refresh details": "تحديث التفاصيل", "Register interest": "تسجيل الاهتمام",
  "Opportunity reference": "مرجع الفرصة", "Published disclosure": "الإفصاح المنشور",
  "Checking your registration…": "جارٍ التحقّق من تسجيلك…",
  "You already registered interest.": "سبق أن سجّلت اهتمامك.", "Interest reference": "مرجع تسجيل الاهتمام",
  "Indicative interest amount (OMR)": "مبلغ الاهتمام الإرشادي (ر.ع.)",
  "Interest level": "مستوى الاهتمام", Exploring: "استكشاف", "Serious interest": "اهتمام جاد",
  "Interest note (optional)": "ملاحظة الاهتمام (اختياري)", "Registering interest…": "جارٍ تسجيل الاهتمام…",
  "Sign in to register interest": "سجّل الدخول لتسجيل اهتمامك",
  "Your nonbinding interest is registered.": "تم تسجيل اهتمامك غير الملزم.",
  "An indicative amount records interest only and does not reserve an allocation.": "المبلغ الإرشادي يسجّل اهتمامك فقط ولا يحجز لك أي حصة.",
  "Recorded status: kyc_required. This is not an investment approval.": "الحالة المسجّلة: يتطلب التحقّق من الهوية. هذا ليس اعتماداً للاستثمار.",
  "Recorded status: registered. This is not an investment approval.": "الحالة المسجّلة: تم تسجيل الاهتمام. هذا ليس اعتماداً للاستثمار.",
  "Investment opportunity is unavailable.": "الفرصة الاستثمارية غير متاحة.",
  "This opportunity is not accepting new interest. Refresh its details.": "هذه الفرصة لا تقبل اهتماماً جديداً حالياً. حدّث تفاصيلها.",
  "Your account cannot register investment interest.": "لا يمكن لحسابك تسجيل اهتمام استثماري.",
  "Check the interest fields and try again.": "تحقّق من بيانات الاهتمام وحاول مجدداً.",
  "You already registered interest with different details. Your original registration is unchanged.": "سبق أن سجّلت اهتماماً بتفاصيل مختلفة. لم يتغيّر تسجيلك الأصلي.",
  "Your previous interest needs a staff review. No new registration was created.": "يحتاج تسجيل اهتمامك السابق إلى مراجعة الفريق. لم يتم إنشاء تسجيل جديد.",
  "The opportunity or account changed. Refresh the details before trying again.": "تغيّرت الفرصة أو الحساب. حدّث التفاصيل قبل المحاولة مجدداً.",
  "Enter a non-negative OMR amount with at most three decimal places.": "أدخل مبلغاً صفراً أو موجباً بالريال العُماني لا يزيد على ثلاث منازل عشرية.",
  "Investment service is temporarily unavailable. Please try again.": "خدمة فرص الاستثمار غير متاحة مؤقتاً. حاول مجدداً.",
  "Could not load investment information. Please try again.": "تعذّر تحميل معلومات الاستثمار. حاول مجدداً.",
});
Object.assign(dictionary.ar, {
  "New interest requires both public approval and this explicit control. Existing records without a value are closed to new interest.": "يتطلب تسجيل اهتمام جديد اعتماد العرض العام وتفعيل هذا الخيار صراحةً. السجلات القديمة دون قيمة لا تقبل اهتماماً جديداً.",
  "Try again": "حاول مجدداً",
  "Checking your account…": "جارٍ التحقّق من حسابك…",
});

Object.assign(dictionary.ar, {
  "Generated summaries use current public property facts. They do not verify the property, ownership or legal eligibility.": "تستخدم الملخصات الحقائق العامة الحالية للعقار، ولا تُثبت صحة العقار أو الملكية أو الأهلية القانونية.",
  "Generating summary…": "جارٍ إنشاء الملخص…",
  "Demo summary — no live AI generation": "ملخص تجريبي — دون توليد مباشر بالذكاء الاصطناعي",
  "AI-generated summary — unverified": "ملخص مولّد بالذكاء الاصطناعي — غير متحقّق منه",
  "A current AI summary has not been generated. Use the property details above.": "لم يُنشأ ملخص حالي بالذكاء الاصطناعي. يمكنك استخدام تفاصيل العقار أعلاه.",
  "Generate AI summary": "إنشاء ملخص بالذكاء الاصطناعي", "Generate a fresh summary": "إنشاء ملخص جديد", "Try summary again": "إعادة محاولة الملخص",
  "This property is unavailable for AI summary.": "هذا العقار غير متاح لملخص الذكاء الاصطناعي.",
  "You cannot run this private AI analysis.": "ليست لديك صلاحية إجراء هذا التحليل الخاص بالذكاء الاصطناعي.",
  "AI is temporarily unavailable. The property information is still available.": "الذكاء الاصطناعي غير متاح مؤقتاً. ما زالت معلومات العقار متاحة.",
  "Check the AI request fields and try again.": "تحقّق من بيانات طلب الذكاء الاصطناعي وحاول مجدداً.",
  "The property changed. Refresh its details before trying again.": "تغيّر العقار. حدّث تفاصيله قبل المحاولة مجدداً.",
  "The source changed. Refresh before trying again.": "تغيّر المصدر. حدّث المعلومات قبل المحاولة مجدداً.",
  "Yield (unverified)": "العائد (غير متحقّق منه)",
});

Object.assign(dictionary.ar, { "Generated AI text": "النص المولّد بالذكاء الاصطناعي", "Generated AI text is unverified. Demo responses are labeled.": "النص المولّد بالذكاء الاصطناعي غير متحقّق منه. تُميّز الردود التجريبية بوضوح.", "Refresh property details": "تحديث تفاصيل العقار" });

Object.assign(dictionary.ar, {
  "Your session has expired or ended. Please sign in again.": sessionText("ar","ended"),
  "Session verification is temporarily unavailable. Please try again.": sessionText("ar","unavailable"),
  "Your sign-in changed while the request was running. Its response was discarded.": sessionText("ar","changed"),
});

Object.assign(dictionary.en,{service_provider:"Service provider"});
Object.assign(dictionary.ar,{service_provider:"مقدم خدمات"});
Object.assign(dictionary.ar,{
 "This professional capability is unavailable. Review your onboarding status.":"هذه الصلاحية المهنية غير متاحة. راجع حالة التأهيل المهني.",
 "This application changed. Refresh before retrying.":"تغيّر هذا الطلب. حمّل أحدث نسخة قبل إعادة المحاولة.",
 "Professional application or evidence is unavailable.":"الطلب المهني أو مرفقاته غير متاح.",
 "Check the professional application fields.":"تحقق من بيانات الطلب المهني.",
 "Professional onboarding is temporarily unavailable.":"التأهيل المهني غير متاح مؤقتاً.",
 "Observer access is read-only.":"صلاحيات المراقب للقراءة فقط.",
 "Use the scoped professional application workflow.":"استخدم مسار الطلب المهني والمراجعة بحسب الصلاحيات."
});

Object.assign(dictionary.ar,{
 "Organization contact routing is not configured yet.":"لم تُهيأ بعد آلية توجيه استفسارات المؤسسة.",
 "Project contact ownership needs review.":"تحتاج هوية صاحب التواصل للمشروع إلى مراجعة.",
 "Provider contact ownership needs review.":"تحتاج هوية صاحب التواصل لمقدم الخدمة إلى مراجعة.",
 "Your organization context changed. Reload before retrying.":"تغيرت مساحة عمل المؤسسة. حدّث المعلومات قبل إعادة المحاولة.",
 "Organization access is unavailable for this account or membership.":"الوصول إلى المؤسسة غير متاح لهذا الحساب أو العضوية.",
 "Organization information changed. Reload before retrying.":"تغيرت معلومات المؤسسة. حدّثها قبل إعادة المحاولة.",
 "Organization services are temporarily unavailable.":"خدمات المؤسسات غير متاحة مؤقتًا.",
 "Organization, membership or invitation is unavailable.":"المؤسسة أو العضوية أو الدعوة غير متاحة.",
 "Check the organization fields.":"تحقق من بيانات المؤسسة."
});

Object.assign(dictionary.ar,{
 "Check the agency work fields.":"تحقق من بيانات عمل الوكالة.",
 "Agency work is unavailable for this account, membership or assignment.":"عمل الوكالة غير متاح لهذا الحساب أو العضوية أو التكليف.",
 "Agency inquiry is unavailable.":"استفسار الوكالة غير متاح.",
 "This agency inquiry changed. Refresh before retrying.":"تغير استفسار الوكالة. حدّث المعلومات قبل إعادة المحاولة.",
 "Agency work is temporarily unavailable.":"عمل الوكالة غير متاح مؤقتًا."
});
